export default __webpack_public_path__ + "static/media/profile.e41538d6.svg";